/**
 * "Showing X of Y+ providers/learners within Z km" - the shared count line both map pages render
 * the same way. Y is the larger of what actually passed every local filter and what Signals-DPG's
 * own {@code meta.total} reported; the "+" is shown only when the network itself said there was
 * more past what this search fetched (`moreOnNetwork`) - not whenever the network figure exceeds
 * the local one, which also happens from ordinary local filtering (blocked, own profile, ...) and
 * would otherwise wrongly imply narrowing filters could surface more.
 */
export function ResultCountSummary({
  shown,
  totalInRadius,
  networkTotal,
  moreOnNetwork,
  radiusKm,
  label,
}: {
  shown: number
  totalInRadius: number
  networkTotal: number
  moreOnNetwork: boolean
  radiusKm: number
  label: string
}) {
  return (
    <>
      {' '}Showing <strong className="text-ink-900">{shown}</strong> of{' '}
      <strong
        className="text-ink-900"
        title={moreOnNetwork ? 'There are more than this within range - narrow the radius or your filters to see others.' : undefined}
      >
        {Math.max(totalInRadius, networkTotal)}
        {moreOnNetwork && '+'}
      </strong>{' '}
      {label} within {radiusKm} km
    </>
  )
}
